import React from 'react';

interface Props {
    exibir: boolean;
}

const Buscando = ({ exibir }: Props): React.ReactElement =>
{
    return (
        <React.Fragment>
            { exibir && (
                <div className="h3 d-flex justify-content-center align-items-center flex-grow-1">
                    <span className="spinner-grow me-3"></span>
                    Buscando registros...
                </div>
            ) }
        </React.Fragment>
    )
}

export default Buscando;
